import { render, staticRenderFns } from "./project-notifications.vue?vue&type=template&id=49d6f84e"
import script from "./project-notifications.vue?vue&type=script&lang=js"
export * from "./project-notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports